export default __webpack_public_path__ + "static/media/sort.22863b96.svg";